import { useQuery } from '@tanstack/react-query';
import { apiClientWithMeta } from '../services/api';
import type { DashboardResponse } from '../types/dashboard';

export function dashboardQueryKey(projectId: string, incidentId: string) {
  return ['projects', projectId, 'incidents', incidentId, 'dashboard'] as const;
}

async function fetchDashboard(projectId: string, incidentId: string) {
  const { data, dataGeneration } = await apiClientWithMeta<DashboardResponse>(
    `/projects/${projectId}/incidents/${incidentId}/dashboard`,
  );
  return { dashboard: data, dataGeneration };
}

export function useDashboard(
  projectId: string | null | undefined,
  incidentId: string | null | undefined,
  options?: { enabled?: boolean },
) {
  const enabled = Boolean(projectId && incidentId) && (options?.enabled ?? true);

  return useQuery({
    queryKey: dashboardQueryKey(projectId ?? '', incidentId ?? ''),
    queryFn: () => fetchDashboard(projectId!, incidentId!),
    enabled,
    staleTime: 30_000,
  });
}
